module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./providers/source_type'));
  PluginManager.registerAudienceMatcher('source_type', require('./matchers/source_type'));
};
